
import ControllerProduct from 'Controllers/ControllerProduct'
import ControllerRelatedProducts from 'Controllers/ControllerRelatedProducts'
import EditorLink from 'Editors/EditorLink'
import ReletedProducts from '../ecommerce/shop/reletedProducts/ReletedProducts'

export default {
  components: {
    ReletedProducts,
    ControllerProduct,
    ControllerRelatedProducts,
    EditorLink,
  },
}
